// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type FetchCatalogsByIdsParams = {
    authToken: string,
    catalogIds: number[],
    deployment: string,
};

type FetchCuratorsForCatalogParams = {
    catalogId: number,
    deployment: string,
};

type FetchRegisteredCatalogsParams = {
    authToken: string,
    deployment: string,
};

type FetchUpcomingCatalogsParams = {
    authToken: string,
    deployment: string,
    forceUpdate: boolean,
    pageSize: number,
    today: boolean,
};

type PostCatalogItemsParams = {
    authToken: string,
    catalogId: number,
    count?: number | string,
    cursor: any,
    deployment: string,
    itemId?: number,
    page?: number,
};

type PostRegisterForCatalogParams = {
    authToken: string,
    bidderId: number,
    catalogId: number,
    deployment: string,
    itemId: number,
};

export default {
    fetchCatalogsByIds: ({ authToken, catalogIds, deployment }: FetchCatalogsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/catalogs' });
            request.send({ ids: catalogIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchCuratorsForCatalog: ({ catalogId, deployment }: FetchCuratorsForCatalogParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ deployment, path: `<ITEM-API>catalog/${catalogId}/curators` });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchRegisteredCatalogs: ({ authToken, deployment }: FetchRegisteredCatalogsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<ITEM-API>catalog/registration' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchUpcomingCatalogs: ({ authToken, deployment, forceUpdate, pageSize, today }: FetchUpcomingCatalogsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<ITEM-API>spa/small/upcomingcatalogs' });
            const query = {};
            if (pageSize) {
                query.pageSize = pageSize;
            }
            if (today) {
                query.today = true;
            }
            if (forceUpdate) {
                query.bustLocalCache = Date.now();
            }
            request.query(query);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postCatalogItems: ({ authToken, catalogId, count, deployment, cursor, itemId, page }: PostCatalogItemsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/catalog/items' });
            const data = {};

            if (cursor) {
                data.cursor = cursor;
                data.wrap = true;
            }

            if (page) {
                data.page = page;
            }

            if (count) {
                data.pageSize = count;
            }

            if (itemId) {
                data.itemId = itemId;
            }

            if (global.__SERVER__ && !cursor && cursor !== 0 && typeof page === 'number' && typeof count === 'number') {
                data.cursor = (page - 1) * count;
            }
            request.type('form');
            request.send({ catalogId, ...data });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postRegisterForCatalog: ({ authToken, bidderId, catalogId, deployment, itemId }: PostRegisterForCatalogParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: `catalog/${catalogId}/bidder/${bidderId}/register`,
                authToken,
                deployment,
                path: '<APPROVAL-API>',
            });
            request.send({
                acceptTerms: true,
                lotId: itemId,
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
